<div
  class="select input"
  [ngClass]="{
    'input--highlight': highlightError | async,
    'input--icon': !!selectorIcon,
    'select--has-value': alwaysShowValue || (internalControl.value !== undefined && internalControl.value !== null),
    'select--menu-open': isOpen,
    'select--display': !isOpen,
    'select--disabled': !enabled,
    'select--invalid': !internalControl.valid,
    'input--invalid': !internalControl.valid,
    'select--touched': internalControl.touched,
    'input--touched': internalControl.touched,
    'select--hide-label': !!hideLabel,
    'select--clearable': showClearButton,
    'select--has-clear-value': showClearButton && hasSelectedValue(),
  }"
  (clickOutside)="close()"
  [openState]="isOpen"
>
  <div class="select__value-container">
    @if (selectorIcon) {
      <svg class="input__icon select__left-icon" [ftrIcon]="selectorIcon" iconColor="Grey40" [iconSize]="24"></svg>
    }
    <div
      #selectValue
      tabindex="0"
      class="select__button"
      role="button"
      aria-haspopup="listbox"
      [attr.aria-expanded]="isOpen"
      [attr.aria-labelledby]="id + '-expand-label'"
      [attr.aria-activedescendant]="isOpen ? activeDescendantId : null"
      (click)="open()"
    >
      {{ openedMenuLabel }}
    </div>
    <div class="select__value">
      {{ selectedLabel }}
    </div>
    <label [id]="id + '-expand-label'" class="select__label" [for]="selectValue">{{ label }}</label>
    <span class="select__bar input__bar"></span>
    @if (showClearButton && hasSelectedValue() && enabled) {
      <a
        tabindex="0"
        class="select__clear-button input__search-clear"
        ftrButton
        ftrStopPropagation
        displayType="text"
        ftrFocusableNoopAnchor
        (click)="clearValue($event)"
        (keydown.enter)="clearValue($event)"
        ftrTooltip
        message="Clear"
        [showDash]="false"
      >
        <svg ftrIcon="Close" iconColor="Grey40" [iconSize]="24" class="align-sub"></svg>
      </a>
    }
    <svg class="select__arrow select__arrow--right" ftrIcon="ChevronRight" [iconSize]="24"></svg>
    <svg class="select__arrow select__arrow--down" ftrIcon="ArrowDown" [iconSize]="24"></svg>
    <span
      class="input__validation select__validation"
      ftrValidationErrorHint
      [label]="label"
      [ngFormControl]="internalControl"
      [controlTouched]="internalControl.touched"
      [submitAttempted]="submitAttempted"
    ></span>
  </div>
  @if (items$ | async; as items) {
    <div
      class="select__open-menu-container"
      role="listbox"
      [attr.aria-required]="required"
      [attr.aria-labelledby]="id + '-label'"
    >
      <div class="select__input-container">
        <button type="button" ftrButton displayType="icon" class="select__close" (click)="close()">
          <svg ftrIcon="ChevronLeft" [iconSize]="24"></svg>
        </button>
        <span class="select__opened-label" [id]="id + '-label'">{{ openedMenuLabel }}</span>
      </div>
      <div class="select__items" [id]="id">
        @for (item of getDisplayItems(items); track item; let i = $index) {
          <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -- it is focusable -->
          <div
            class="select__item"
            [ngClass]="{
              'select__item--selected': item.value === internalControl.value,
            }"
            role="option"
            [id]="id + '-item-' + i"
            [attr.aria-selected]="item.value === internalControl.value"
            (click)="setValue(item.value)"
            (keydown.enter)="setValue(item.value)"
          >
            {{ item.key }}
          </div>
        }
      </div>
    </div>
  }
</div>
